export const normalizeId = (value) => String(value?._id || value?.id || value || '').trim();

export const normalizeGaliPlayerRef = (ref = {}) => {
  if (!ref || (typeof ref === 'object' && !Object.keys(ref).length)) return null;
  const refType = ref.refType || (ref.tempPlayerId || ref.tempNumber || ref.tempNumberSnapshot ? 'temp' : ref.savedGaliPlayerId ? 'saved' : 'player');
  const playerId = normalizeId(ref.playerId || (refType === 'player' ? (ref.id || ref._id) : null)) || null;
  const tempPlayerId = normalizeId(ref.tempPlayerId || (refType === 'temp' ? (ref.id || ref._id) : null)) || null;
  const savedGaliPlayerId = normalizeId(ref.savedGaliPlayerId || (refType === 'saved' ? (ref.id || ref._id) : null)) || null;
  const participantKey = ref.participantKey || (tempPlayerId ? `temp:${tempPlayerId}` : playerId ? `player:${playerId}` : savedGaliPlayerId ? `saved:${savedGaliPlayerId}` : '');
  const displayNameSnapshot = ref.displayNameSnapshot || ref.displayName || ref.name || ref.fullName || 'Unknown Player';
  return {
    ...ref,
    refType,
    playerId,
    tempPlayerId,
    savedGaliPlayerId,
    participantKey,
    displayName: ref.displayName || displayNameSnapshot,
    displayNameSnapshot,
    tempNumber: ref.tempNumber || ref.tempNumberSnapshot || null,
    tempNumberSnapshot: ref.tempNumberSnapshot || ref.tempNumber || null,
    status: ref.status || 'active',
    isTemporary: ref.isTemporary ?? refType === 'temp',
  };
};

export const playerRefKey = (ref = {}) => {
  const normalized = normalizeGaliPlayerRef(ref);
  if (!normalized) return '';
  if (normalized.participantKey) return normalized.participantKey;
  if (normalized.refType === 'player') return `player:${normalizeId(normalized.playerId)}`;
  if (normalized.refType === 'temp') return `temp:${normalizeId(normalized.tempPlayerId)}`;
  if (normalized.refType === 'saved') return `saved:${normalizeId(normalized.savedGaliPlayerId)}`;
  return '';
};

export const buildPlayerRef = (player = {}) => {
  if (!player) return null;
  const normalized = normalizeGaliPlayerRef(player);
  if (!normalized) return null;
  if (normalized.refType === 'temp' && normalized.tempPlayerId) return { refType: 'temp', tempPlayerId: normalized.tempPlayerId, participantKey: normalized.participantKey };
  if (normalized.refType === 'saved' && normalized.savedGaliPlayerId) return { refType: 'saved', savedGaliPlayerId: normalized.savedGaliPlayerId, participantKey: normalized.participantKey };
  if (normalized.playerId) return { refType: 'player', playerId: normalized.playerId, participantKey: normalized.participantKey };
  return null;
};

export const toScoringPlayerRef = (ref = {}) => {
  const normalized = normalizeGaliPlayerRef(ref);
  if (!normalized) return null;
  return {
    refType: normalized.refType,
    playerId: normalized.playerId,
    tempPlayerId: normalized.tempPlayerId,
    savedGaliPlayerId: normalized.savedGaliPlayerId,
    participantKey: normalized.participantKey,
  };
};

export const normalizePickerPlayer = (player = {}, sourceType = '') => {
  const normalized = normalizeGaliPlayerRef({ ...player, refType: sourceType || player.refType || player.type || player.sourceType });
  const ref = buildPlayerRef(normalized);
  return {
    ...player,
    ...normalized,
    id: normalizeId(player.id || player._id || normalized.playerId || normalized.tempPlayerId || normalized.savedGaliPlayerId),
    ref,
    refKey: playerRefKey(ref),
  };
};
